export function successMessageMapping (message) {
  let newMessage

  if (message === 'request-password') {
    newMessage = 'common_resetPassword_placeholder'
  } else {
    newMessage = 'Success.'
  }

  return newMessage
}

export function errorMessageMapping (message, callNewRelic = true) {
  let newMessage

  if (callNewRelic && window.newrelic) {
    window.newrelic.noticeError(message)
  }

  switch (message.trim()) { // We need to trim the message as sometimes there are extra whitespaces
    case 'User does not exist.':
      newMessage = 'common_emailNotRecognized_text'
      break
    case 'PreSignUp failed with error User already exist!.':
      newMessage = 'common_accountPresent_text'
      break
    case 'Incorrect username or password.':
      newMessage = 'common_incorrectEmail_text'
      break
    case 'PreTokenGeneration failed with error user not authenticated.':
      newMessage = 'common_emailNotRecognized_text'
      break
    case 'PreTokenGeneration failed with error user has a zava account already.':
      newMessage = 'common_accountPresent_text'
      break
    case 'PreTokenGeneration failed with error account has a problem.':
      newMessage = 'Your account has been suspended. Please contact our customer support team on {phoneNumber}'
      break
    case 'Attempt limit exceeded, please try after some time.':
      newMessage = 'common_attemptLimit_text'
      break
    case 'Custom auth lambda trigger is not configured for the user pool.':
    case 'Password attempts exceeded':
    case 'You have entered the wrong code too many times. You can try again in 10 minutes.':
      newMessage = 'common_tryAgain_text'
      break
    case 'An account with the given email already exists.':
      newMessage = 'common_accountPresent_text'
      break
    case 'Invalid code provided, please request a code again.':
      newMessage = 'common_codeExpired_text'
      break
    case 'PreSignUp failed with error patient not found.':
      newMessage = 'common_notifyLogin_text'
      break
    // This message also applies to existing SAE users attempting Google SSO.
    case 'PreSignUp failed with error user has a zava account already.':
      newMessage = 'common_loginTraditionally_text'
      break
    case 'Username/client id combination not found.':
      newMessage = 'common_incorrectEmail_text'
      break
    case 'Invalid verification code provided, please try again.':
      newMessage = 'common_invalidVerificationCode_text'
      break
    case 'User is not confirmed.':
    case 'Cannot reset password for the user as there is no registered/verified email or phone_number':
      newMessage = 'common_passwordReset_text'
      break
    case 'Password reset required for the user':
      newMessage = 'common_passwordExpired_text'
      break
    case 'PreSignUp failed with error User has incomplete Google SSO account.':
      newMessage = 'common_accountIncompleteSso_text'
      break
    default:
      newMessage = 'common_tryagainError_text'
  }

  return newMessage
}
